(function ($) {
    var Scripts = {
        init() {
            console.log('Scripts Loaded');

            // this.bLazy();
            this.dropDownMenu();
            this.startSlider();
            this.bindEvents();
            this.startupKit();
            this.disableGFormEnter();
            this.hideAlerts();
            this.popupModal();
            this.filterList();
            this.handleHashLinks();

            // this.accordianScroll();
            this.showHomeVideo(document.getElementById('bgvid'));
            this.sticky();
            // this.adminSectionLinks();
        },

        startupKit() {
            var self = this;
            $(document).ready(function () {
                // setTimeout(function() {
                //   $('html').addClass('loaded');
                // }, 400);

                // self.showHomeVideo();
                self.swiperPrep();
            });
        },

        bLazy() {
            // Lazy Load images
            // Initialize on .b-lazy class
            document.addEventListener('DOMContentLoaded', function () {
                let bLazy = new Blazy({});
            }, false);
        },

        startSlider() {
            var self = this;
            var $sliders = $('.slider'); // return array of elements
            var speed = 6000;

            function destroy() {
                if (typeof self.sliderTimer !== "undefined") {
                    clearInterval(self.sliderTimer);
                }
            }

            function changeSlide() {
                $sliders.each(function (idx) {
                    var thisSlides = $(this).find('.slide');
                    var slidecount = thisSlides.length;
                    var activeIdx = thisSlides.parent().find('.showing').index();
                    var nextIdx = (activeIdx >= (slidecount - 1)) ? 0 : activeIdx + 1;
                    var $next = thisSlides.eq(nextIdx); // finds the ith element

                    $(this).find(".showing").removeClass("showing");
                    $next.addClass("showing");
                    // update dots
                    $(this).find('.dot.active').removeClass("active");
                    $(this).find('.dot').eq(nextIdx).addClass("active");
                });
            }

            function showSlide(container, slideindex) {
                destroy();

                let $next = $(container).find(".slide").eq(slideindex); // finds the ith element
                $(container).find(".showing").removeClass("showing");
                $next.addClass("showing");
                // update dots
                $(container).find('.dot.active').removeClass("active");
                $(container).find('.dot').eq(slideindex).addClass("active");

                // i = (slideindex >= (slidecount - 1)) ? 0 : slideindex + 1;

                begin();
            }

            function showNext(container) {
                let targetIdx = $(container).find('.dot.active').data('idx');
                var slidecount = $(container).find('.slide').length;
                let n = (targetIdx >= (slidecount - 1)) ? 0 : targetIdx + 1;
                showSlide(container, n);
            }

            function showPrev(container) {
                let targetIdx = $(container).find('.dot.active').data('idx');
                var slidecount = $(container).find('.slide').length;
                let n = (targetIdx === 0) ? slidecount - 1 : targetIdx - 1;
                showSlide(container, n);
            }

            function begin() {
                self.sliderTimer = setInterval(changeSlide, speed);
            }

            $(document).on("click", ".slide-control .dot", function (ev) {
                var targetIdx = $(ev.target).data('idx');
                var container = $(ev.target).parents('.slider');
                showSlide(container, targetIdx);
            });
            $(document).on("click", ".slide-arrows .nav-left", function (ev) {
                ev.preventDefault();
                var container = $(ev.target).parents('.slider');
                showPrev(container);
            });
            $(document).on("click", ".slide-arrows .nav-right", function (ev) {
                ev.preventDefault();
                var container = $(ev.target).parents('.slider');
                showNext(container);
            });

            let element = document.getElementById("slider");
            if (element) {
                let options = {
                    dragLockToAxis: true,
                    dragBlockHorizontal: true,
                };
                let hammertime = new Hammer(element, options);
                hammertime.on("swipeleft", function (ev) {
                    ev.preventDefault();
                    var container = $(ev.target).parents('.slider');
                    // console.log(ev.type + " gesture detected. target index: " + targetIdx + "slidecount:" + slidecount);
                    showNext(container);
                });
                hammertime.on("swiperight", function (ev) {
                    ev.preventDefault();
                    var container = $(ev.target).parents('.slider');
                    // console.log(ev.type + " gesture detected. target index: " + targetIdx + "slidecount:" + slidecount);
                    showPrev(container);
                });
            }

            if ($sliders) {
                begin();
            }
        },

        bindEvents() {
            var self = this;
            // show mobile nav
            $(document).on("touchstart, click", ".navbar .btn-navbar", function (e) {
                e.preventDefault();
                $('html.nav-visible').find('.nav-collapse').hide();
                $(".navbar").find('.nav-collapse').show();
                $(".navbar").toggleClass('nav-visible');
                $('html').toggleClass('nav-visible');
            });

            // always close mobile nav
            $(document).on("click", ".nav-visible .nav-top li a", function () {
                self._close_nav();
            });

            // search click
            $(document).on("click", ".nav-top .search-form .glyphicon-search", function () {
                $(".nav-top .search-form").submit();
            });

            // hero vertical height
            $(document).ready(function () {
                self.resizeDiv();
                self.equalHeight();
            });
            window.onresize = function () {
                self.resizeDiv();
                self.equalHeight();
            };

            // prevent page change on accordion
            $(document).on("click", ".accordian .panel-heading a", function (ev) {
                ev.preventDefault();
            });

            // Show states modal
            $('#statesModal').on('show.bs.modal', function (event) {
                var button = $(event.relatedTarget);
                var state = button.data('state');
                var modal = $(this);
                modal.find('.state-list').hide();
                modal.find('.' + state).show();
                console.log("looking for ", state);
            });

            // show users modal
            $('#userModal').on('show.bs.modal', function (event) {
                var button = $(event.relatedTarget);
                var user = button.data('user');
                var modal = $(this);
                modal.find('.staff-detail-block').hide();
                modal.find('#' + user).show();
                console.log("looking for ", user);
            });

            // show position modal
            $('#applicationModal').on('show.bs.modal', function (event) {
                var button = $(event.relatedTarget);
                var position = button.data('position');
                var modal = $(this);
                modal.find('.position-detail-block').hide();
                modal.find('#' + position).show();
                console.log("looking for ", position);
            });

            // blazy the images in modal after it loads!
            $('#userModal, #applicationModal').on('shown.bs.modal', function (event) {
                var bLazy = new Blazy();
                bLazy.revalidate();
            });

            // click facebook share 
            // $(document).on('click', '#facebookshare', function(ev) {
            //   ev.preventDefault();
            //   $(document).find('.fb-like').click();
            // });


            // Email modal 
            // populate contract form
            $(document).on("click", ".populate-modal", function (e) {
                e.preventDefault();
                var target_ste = $(e.target).data('ste');
                var target_name = $(e.target).data('name');
                var modal_field = $('.gfield.hidden-field input').first();
                modal_field.attr('value', target_ste);
                $("#modal-contact-name").html(target_name);
            });
            $(document).on("click", "#contactFormModal .close", function (e) {
                e.preventDefault();
                var default_ste = $('#default-contact').data('ste');
                var default_name = $('#default-contact').data('name');
                var modal_field = $('.gfield.hidden-field input').first();
                modal_field.attr('value', default_ste);
                $("#modal-contact-name").html(default_name);
            });

            $(document).on("submit", "#contactFormModal .gform_wrapper form", function () {
                setTimeout(function () {
                    document.location.reload();
                }, 3000);
            });
        },

        popupModal() {
            let self = this;
            let popModal = $('#popupModal');

            if (popModal.length) {

                // check for previously completed form
                // specific to this page
                let pageid = popModal.data('postid');
                let previouslyCompleted = localStorage.getItem('hidePopup' + pageid);
                if (previouslyCompleted) {
                    self.popupHide = true;
                }

                if (popModal.hasClass('show-scroll')) {
                    let showModalScroll = $('#popup-waypoint').waypoint(function (direction) {

                        let mobileBreakpoint = 768;
                        let vpw = $(window).width();

                        if (direction === 'up') {
                            // scroll up codes.
                        }
                        if (direction === 'down' && !self.popupHide) {
                            console.log('popup primed and ready for launch', direction);
                            self.popupReady = true;
                        }
                    }, {
                        offset: '0px',
                    });
                } else if (popModal.hasClass('show-time') && !self.popupHide) {
                    let timeout = popModal.data('timeout');
                    setTimeout(function () {
                        popModal.modal('show');
                    }, timeout * 1000);
                }

                var lastScrollTop = 0;
                window.addEventListener("scroll", function () {
                    var st = window.pageYOffset || document.documentElement.scrollTop;
                    if (st > lastScrollTop) {
                        // downscroll code
                    } else {
                        // when user scrolls up
                        // after passing a specific waypoint
                        // fire the modal immediately.
                        if (self.popupReady && !self.popupHide) {
                            setTimeout(function () {
                                popModal.modal('show');
                            }, 200);
                        }
                    }
                    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
                }, false);

                $(document).on("hide.bs.modal", "#popupModal", function (e) {
                    // store for this session
                    // user manually hid the modal
                    // don't bother them anymore.
                    self.popupHide = true;
                });

                $(document).on("gform_confirmation_loaded", function () {
                    // store for this browser 
                    // as long as the browser will allow
                    // user submitted the modal form
                    // don't show the popup anymore.
                    localStorage.setItem('hidePopup' + pageid, true);
                    setTimeout(function () {
                        document.location.reload();
                    }, 3000);
                });
            }
        },

        equalHeight() {
            let target = $(document).find('.equalheight');
            let width = target.width();
            target.height(width);
        },


        accordianScroll() {
            // Accordian opening
            $(".accordian").on("shown.bs.collapse", function () {
                var myEl = $(this).find('.collapse.in').prev('.panel-heading');
                var distance = $(myEl).offset().top - 60;
                console.log("scrolling the ", myEl, distance);

                $('html, body').animate({
                    scrollTop: distance,
                }, {
                    duration: 400,
                    specialEasing: {
                        height: "easeOut",
                    },
                });
            });

            // Accordian opening
            $(".accordian").on("hide.bs.collapse", function () {
                var myEl = $(this).find('.collapse.in').prev('.panel-heading');
                var distance = $(myEl).offset().top - 60;
                console.log("scrolling the ", myEl, distance);

                $('html, body').animate({
                    scrollTop: distance,
                }, {
                    duration: 600,
                    specialEasing: {
                        height: "easeIn",
                    },
                });
            });
        },

        resizeDiv() {
            let mobileBreakpoint = 768;
            let vpw = $(window).width();
            let vph = $(window).height();
            let bottommargin = -240;
            let heroheight = vph + bottommargin;
            let homeheight = heroheight;
            let shortheroheight = vph / 2.75;
            let blogheight = vph / 1.66;
            let heroh1height = $('.hero h1').height();

            if (blogheight > 650) {
                blogheight = 650;
            } else if (blogheight < 350) {
                blogheight = 470;
            }
            if (heroheight > 650) {
                heroheight = 650;
            } else if (heroheight < 470) {
                heroheight = 470;
                homeheight = 470;
            }

            if (shortheroheight < 420) {
                shortheroheight = 420;
            }

            $('#blog').css({ 'height': blogheight + 'px' });
            $('.blog-bg').css({ 'height': blogheight + 'px' });
            // $('.slider_container').css({'height': blogheight + 'px'});

            if (vpw < mobileBreakpoint) {
                homeheight = homeheight - 100;
                heroheight = heroheight - 100;
                $('#top-nav').addClass('mobile-nav');

                $('.hero-short').css({ 'height': shortheroheight + 'px' });
                $('.hero-short .hero-bg').css({ 'height': shortheroheight + 'px' });
                $('.hero-short h1').css({ 'margin-top': (shortheroheight / 3) - (heroh1height / 2) });

                $('.hero-tall').css({ 'height': heroheight + 'px' });
                $('.hero-tall .hero-bg').css({ 'height': heroheight + 'px' });
                $('.hero-tall h1').css({ 'margin-top': (heroheight - heroh1height) / 3.2 + 'px' });

                $('.hero-home').css({ 'height': homeheight + 'px' });
                $('.hero-home .hero-bg').css({ 'height': homeheight + 'px' });
                // $('.hero-home h1').css({ 'margin-top': (homeheight / 3.2) - (heroh1height / 2) });

                $('#blog.single header').css({ 'margin-top': blogheight * 0.2 + 'px' });
                $('#blog.slider header').css({ 'margin-top': blogheight * 0.3 + 'px' });
            } else {
                $('#top-nav').removeClass('mobile-nav');

                $('.hero-short').css({ 'height': shortheroheight + 'px' });
                $('.hero-short .hero-bg').css({ 'height': shortheroheight + 'px' });
                $('.hero-short h1').css({ 'margin-top': (shortheroheight / 3) - (heroh1height / 2) });

                $('.hero-tall').css({ 'height': heroheight + 'px' });
                $('.hero-tall .hero-bg').css({ 'height': heroheight + 'px' });
                // $('.hero-tall h1').css({ 'margin-top': (heroheight - heroh1height) / 2 + 'px' });

                $('.hero-home').css({ 'height': homeheight + 'px' });
                $('.hero-home .hero-bg').css({ 'height': homeheight + 'px' });
                // $('.hero-home h1').css({ 'margin-top': (homeheight / 2) - (heroh1height / 2) });

                $('#blog.single header').css({ 'margin-top': blogheight * 0.3 + 'px' });
                $('#blog.slider header').css({ 'margin-top': blogheight * 0.3 + 'px' });
            }
        },

        filterList() {
            let self = this;
            /*
             * Click a Category
             */
            $(document).on("click", ".filter > li > a", function (e) {
                e.preventDefault();
                let $parentList = $(e.target).closest('ul.filter').first();

                // clear all active li for cats and subs
                $parentList.find('li').removeClass('active');

                // setup new active cat
                let $li = $(e.target).parent('li');
                let cat = $li.data('cat');
                $li.addClass('active');
                console.log('category selected: ', cat);
                localStorage.setItem('cat', cat);

                // filter subcategory list
                let $filteredList = $('.filtered-list');

                $filteredList.addClass('filtering');
                if (cat === 'all') {
                    $filteredList.find('.filter-item').addClass('visible');
                } else {
                    $filteredList.find('.filter-item').removeClass('visible');
                    $filteredList.find(`[data-cat*='${cat}']`).addClass('visible');  
                }

                if ($filteredList.hasClass('masonry')) {
                    var $grid = $filteredList.masonry({
                        itemSelector: '.m-item.visible',
                        columnWidth: '.m-item.visible',
                        transitionDuration: 0
                    });
                }
            });
        },

        sticky() {
            document.addEventListener('DOMContentLoaded', function () {
                // Sticky nav
                if (document.getElementById('breadcrumbs')) {
                    let offset = '91px';
                    if ($('.showAlert').length > 0) {
                        offset = '150px';
                    }
                    var waypoint = new Waypoint.Sticky({
                        element: document.getElementById('breadcrumbs'),
                        offset,
                    });

                    // stick nav on video hero pages.
                    if ($('body.video-hero')) {
                        let videoHeroWaypoint = $('#breadcrumbs').waypoint(function (direction) {
                            if (direction === 'up') {
                                $('.site-header.fixed').removeClass('stuck');
                            }
                            if (direction === 'down') {
                                $('.site-header.fixed').addClass('stuck');
                            }
                        }, {
                            offset,
                        });
                    }
                }

                // Home Nav
                if (document.getElementById('start-content')) {
                    let homenav = $('#start-content').waypoint(function (direction) {


                        console.log('content hit window top', direction);
                        if (direction === 'up') {
                            $('body').addClass('white-homey');
                        }
                        if (direction === 'down') {
                            $('body').removeClass('white-homey');
                        }
                    }, {
                        offset: '0px',
                    });
                }

                // Camp Detail
                if (document.getElementById('camp-banner')) {
                    let banner = $('#sticky-banner').waypoint(function (direction) {

                        console.log('content hit window top', direction);
                        if (direction === 'down') {
                            $('body').addClass('stuck');
                        }
                        if (direction === 'up') {
                            $('body').removeClass('stuck');
                        }
                    }, {
                        offset: '0px',
                    });
                }
            });
        },

        dropDownMenu() {
            $(document).ready(function () {
                $(".menu-item").hover(
                    function () {
                        $(this).children(".sub-menu").stop(true, true).css("display", "flex").hide().fadeIn(200);
                    },
                    function () {
                        $(this).children(".sub-menu").stop(true, true).fadeOut(200, function () {
                            $(this).css("display", "none");
                        });
                    }
                );
            });
        },


        buildSwiper(autoplay) {
            $('.slides').on('lazyLoaded', function(event, slick, image, imageSource){
            if (!$('body').hasClass('swiper-ready')) {
                $('body').addClass('swiper-ready');
            }
            });
            
            if(autoplay == undefined){
            autoplay = false;
            }
    
            let initial = 0;
            if($('.mobile-gallery').length > 0){
            let count = parseInt($('.mobile-gallery').first().data('count')) - 1;
            initial = Math.floor( Math.random() * count )
            }
    
            $(".slides").slick({
            infinite: true,
            speed: 2000,
            autoplaySpeed: 5000,
            fade: true,
            cssEase: 'ease-in-out',
            arrows: false,
            lazyLoad: 'ondemand',
            waitForAnimate: false,
            autoplay: autoplay,
            initialSlide: initial
            });
    
            $(".slides").on('afterChange', (e, slick, curSlide) => {
            let newIdx = $(".slides").slick('slickCurrentSlide');
            $('#slide_num').text(newIdx + 1);
            });
    
            return true;
        },
    
        swiperClose() {
            document.body.style.position = 'relative';
            document.body.style.top = 'auto';
            $(document).find('.goback').click();
        },


        swiperPrep() {
            let self = this;
            console.log('swiperPrep');
    
            if (!document.querySelector('.slideshow.gallery')) {
                console.log('swiperPrep: no swiper');
                return false;
            }
    
            if ($('.swiper-container') && !$('.swiper-container').hasClass('wp-block-jetpack-slideshow_container')) {
            this.buildSwiper(true);
    
    
            $(document).on('keydown', function(ev) {
                let keyCode = ev.keyCode;
                if (keyCode === 37) {// Left
                $(".slides").slick('slickPrev');
                }
                if (keyCode === 39) { // Right
                $(".slides").slick('slickNext');
                }
            });
    
            $(document).off('click', '.swiper-button-next');
            $(document).on('click', '.swiper-button-next', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $(".slides").slick('slickNext');
            });
    
            $(document).off('click', '.swiper-button-prev');
            $(document).on('click', '.swiper-button-prev', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $(".slides").slick('slickPrev');
            });
            }
    
            return true;
        },
  
  

        showHomeVideo(videoEl) {
            if(!videoEl) {
              return;
            }
            let self = this;
            let video = videoEl;
            let ua = navigator.userAgent;
            let iphone = /iPhone/i.test(ua);
            let android = /Android/i.test(ua);
      
            video.addEventListener("canplay", function() {
              video.play();
              $(video).removeClass('video-wait');
            });
            video.load();
        
        },

        disableGFormEnter() {
            /**
             * Gravity Wiz // Gravity Forms // Disable Submission when Pressing Enter 
             * http://gravitywiz.com/disable-submission-when-pressing-enter-for-gravity-forms/
             */
            $(document).on('keypress', '.gform_wrapper', function (e) {
                var code = e.keyCode || e.which;
                if (code == 13 && !jQuery(e.target).is('textarea,input[type="submit"],input[type="button"]')) {
                    e.preventDefault();
                    return false;
                }
            });
        },

        hideAlerts() {
            let timeNow = Date.now();
            let show = false;
            $('#alert').hide();

            // get localstore
            let alertExists = document.getElementById('alert');
            if (alertExists !== null) {
                let existingAlertId = $('#alert').data('alertid');
                let dismissDate = localStorage.getItem('hiddenAlert' + existingAlertId);
                if (dismissDate !== null && timeNow > dismissDate + 86400000) {
                    show = true;
                } else if (dismissDate === null) {
                    show = true;
                } else if ($('#alert').hasClass('persist')) {
                    show = true;
                }
            }

            // if alert exists and wasn't dismissed, show it
            if (show === true) {
                $('body').addClass('showAlert');
                $('#alert').show().css('height', '60px').css('visibility', 'visible');
            }

            // hide alert on click
            $(document).on('click', '.hideAlert', function (e) {
                e.stopPropagation();

                var eventAlertId = $(e.target).parents('.alert').data('alertid');
                var timeDismissed = Date.now();

                localStorage.setItem('hiddenAlert' + eventAlertId, timeDismissed);
                $('body').removeClass('showAlert');
            });
        },

        adminSectionLinks() {
            $('.admin-viewer section[id]').each(function (idx) {
                let id = $(this).attr('id');
                let newdiv = document.createElement('a');
                newdiv.href += window.location.href + '#' + id;
                newdiv.className += 'idshow';
                newdiv.innerHTML += '#' + id;
                this.append(newdiv);
            });

            let hash = window.location.hash;
            if (hash) {
                $(document).ready(function () {
                    let hh = $("header").height();
                    $('html, body').stop().animate({
                        scrollTop: ($(hash).offset().top - hh)
                    }, 800, 'swing');
                });
            }
        },

        handleHashLinks() {
            $(document).ready(function () {
                if (window.location.hash) {
                    let target = $(window.location.hash);
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top - 90
                        }, 1000);
                    }
                }
                $(document).on('click', 'a[href^="#"]', function (e) {
                    e.preventDefault();
                    let target = $($(this).attr('href'));
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top - 90
                        }, 1000);
                    }
                });
            });
        },

        _close_nav() {
            $('.navbar').removeClass('nav-visible');
            $('html').removeClass('nav-visible');
        },

        _open_nav() {
            $(".navbar").find('.nav-collapse').show();
            $(".navbar").addClass('nav-visible');
            $('html').addClass('nav-visible');
        },

        /**
         * Get URL Parameter
         *
         * @param {string} name
         * @return {string}
         */
        _getUrlParameter(param) {
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)'),
                results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },

        /**
         * Get Hash Parameter
         *
         * Ex. /page/#/param/value
         *
         * @param {string} name
         * @return {string}
         */
        _getHashParameter(param) {
            var paramStr = '/#/' + param + '/',
                paramStrIndex = location.href.indexOf(paramStr);
            if (paramStrIndex !== -1) {
                var pathResult = location.href.substring(paramStrIndex + paramStr.length);
                return pathResult.split('/')[0];
            }
            return '';
        },
    };

    Scripts.init();
})(jQuery);
